import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createProfile({ commit }, data) {
      try {
        return await api.post('/company/profiles', data)
      } catch (error) {
        throw error
      }
    },

    async getProfiles({ commit }) {
      try {
        const response = await api.get('/company/profiles')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getProfile({ commit }, id) {
      try {
        const response = await api.get(`/company/profiles/${id}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateProfile({ commit }, data) {
      try {
        return await api.put(`/company/profiles/${data.id}`, data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
